import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Col, Form } from "react-bootstrap";

import { updateClienteId } from "~/store/ducks/budgetManagement/actionTypes";

import Modal from "react-bootstrap/Modal";
import SimpleButton from "~/pages/Easypay/components/SimpleButton";
import Dropdown from "~/components/Dropdown";

const ModalUpdateClient = ({
  isClicked,
  isClosed,
  companiesList,
  rowObject,
  paymentTypeList,
  clientTypeList,
}) => {
  const [isModalUpdatClientShowing, setIsModalUpdatClientShowing] =
    useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [dropdownInvalid, setDropdownInvalid] = useState(false);
  const [companyValue, setCompanyValue] = useState("");
  const [paymentTypeValue, setPaymentTypeValue] = useState("");

  const dispatch = useDispatch();

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  useEffect(() => {
    if (isClicked) {
      setIsModalUpdatClientShowing(true);
    }
  }, [isClicked]);
  console.log(companiesList, "companiesList");
  const validateForm = () => {
    const { nome, morada, nif, formaPagamento, year, tipoCliente, empresa } =
      form;

    const newErrors = {};
    if (!nome || nome === "" || !isNaN(nome)) {
      newErrors.nome = "Por favor preencha o nome";
    }
    if (!morada || morada === "" || !isNaN(morada)) {
      newErrors.morada = "Por favor preencha a morada.";
    }

    if (!nif || nif === "") {
      newErrors.nif = "Por favor preencha o NIF.";
    }

    if (!empresa || empresa === undefined || empresa === "") {
      newErrors.orgId = "Por favor preencha a empresa.";
    }

    if (!formaPagamento || formaPagamento === "") {
      newErrors.formaPagamento = "Por favor preencha a forma de pagamento.";
    }

    if (!year || year === "" || isNaN(year)) {
      newErrors.year = "Por favor preencha o ano.";
    }

    if (!tipoCliente || tipoCliente === "") {
      newErrors.tipoCliente = "Por favor preencha o tipo de cliente.";
    }
    return newErrors;
  };

  const handleClose = () => setIsModalUpdatClientShowing(false);

  useEffect(() => {
    isClosed(isModalUpdatClientShowing);
  }, [isModalUpdatClientShowing]);

  const handleSaveData = () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setDropdownInvalid(true);
    } else {
      setDropdownInvalid(false);
      dispatch(updateClienteId(form));
      handleClose();
      setForm("");
    }
  };

  const handleDropdownClassName = (varError, boolean) => {
    if (boolean) {
      return (
        "dropdown-margin " +
        (varError === "" || varError === undefined
          ? "dropdown-border-invalid"
          : "")
      );
    }
  };
  useEffect(() => {
    if (Object.keys(rowObject).length > 0 && companiesList.length > 0) {
      for (let i = 0; i < companiesList.length; i++) {
        if (companiesList[i].label === rowObject.empresa) {
          setCompanyValue(companiesList[i].value);
        }
      }
    }
  }, [companiesList, rowObject]);

  useEffect(() => {
    if (Object.keys(rowObject).length > 0 && paymentTypeList.length > 0) {
      for (let i = 0; i < paymentTypeList.length; i++) {
        if (paymentTypeList[i].label === rowObject.empresa) {
          setPaymentTypeValue(paymentTypeList[i].value);
        }
      }
    }
  }, [paymentTypeList, rowObject]);

  useEffect(() => {
    if (Object.keys(rowObject).length > 0) {
      setForm({
        ...form,
        nome: rowObject.nome,
        morada: rowObject.morada,
        empresa: rowObject.empresa,
        year: rowObject.year,
        nif: rowObject.nif,
        formaPagamento: rowObject.formaPagamento,
        numCliente: rowObject.numCliente,
        prazoPagamento: rowObject.prazoPagamento,
        tipoCliente: rowObject.tipoCliente,
        idCliente: rowObject.idCliente,
      });
    }
  }, [rowObject]);

  const handleValues = (event, list) => {
    return list.filter((e) => e.value === event)[0]?.label;
  };
  return (
    <>
      <Modal show={isModalUpdatClientShowing} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alterar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="12" md="12">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  value={form.nome || ""}
                  onChange={(e) => setField("nome", e.target.value)}
                  type="text"
                  isInvalid={!!errors.nome}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nome}
                </Form.Control.Feedback>
              </Col>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="12" md="12">
                <Form.Label>Morada</Form.Label>
                <Form.Control
                  value={form.morada || ""}
                  onChange={(e) => setField("morada", e.target.value)}
                  type="text"
                  isInvalid={!!errors.morada}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.morada}
                </Form.Control.Feedback>
              </Col>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="6" md="6">
                <Form.Label>Empresa</Form.Label>
                <Dropdown
                  list={companiesList}
                  handleSubmit={(e) =>
                    setField("empresa", handleValues(e, companiesList))
                  }
                  defaultValue={form.empresa}
                  className={handleDropdownClassName(
                    form.empresa,
                    dropdownInvalid
                  )}
                />
                <div
                  style={{
                    width: "100%",
                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.empresa}
                </div>
              </Col>
              <Col xl="6" md="6">
                <Form.Label>Ano</Form.Label>
                <Form.Control
                  value={form.year || ""}
                  onChange={(e) => setField("year", e.target.value)}
                  type="text"
                  isInvalid={!!errors.year}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.year}
                </Form.Control.Feedback>
              </Col>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="6" md="6s">
                <Form.Label>NIF</Form.Label>
                <Form.Control
                  value={form.nif || ""}
                  onChange={(e) => setField("nif", e.target.value)}
                  type="text"
                  isInvalid={!!errors.nif}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nif}
                </Form.Control.Feedback>
              </Col>

              <Col xl="6" md="6">
                <Form.Label>Tipo de cliente</Form.Label>
                <Dropdown
                  list={clientTypeList}
                  handleSubmit={(e) => setField("tipoCliente", e)}
                  defaultValue={form.tipoCliente}
                  className={handleDropdownClassName(
                    form.tipoCliente,
                    dropdownInvalid
                  )}
                />

                <div
                  style={{
                    width: "100%",
                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.tipoCliente}
                </div>
              </Col>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="6" md="6">
                <Form.Label>Forma de Pagamento</Form.Label>
                <Dropdown
                  list={paymentTypeList}
                  handleSubmit={(e) =>
                    setField("formaPagamento", handleValues(e, paymentTypeList))
                  }
                  defaultValue={form.formaPagamento}
                  className={handleDropdownClassName(
                    form.formaPagamento,
                    dropdownInvalid
                  )}
                />
                <div
                  style={{
                    width: "100%",
                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.formaPagamento}
                </div>
              </Col>

              <Col xl="6" md="6">
                <Form.Label>Prazo do Pagamento</Form.Label>
                <Form.Control
                  value={form.prazoPagamento || ""}
                  onChange={(e) => setField("prazoPagamento", e.target.value)}
                  type="text"
                  isInvalid={!!errors.prazoPagamento}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.prazoPagamento}
                </Form.Control.Feedback>
              </Col>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {/* <Col xl="6" md="6">
                <Form.Label>Nº Cliente</Form.Label>
                <Form.Control
                  value={form.numCliente || ""}
                  onChange={(e) => setField("numCliente", e.target.value)}
                  type="text"
                  isInvalid={!!errors.numCliente}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.numCliente}
                </Form.Control.Feedback>
              </Col> */}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
            paddingTop: "15px",
          }}
        >
          <SimpleButton
            text={"Fechar"}
            variant={"liftworld-button-primary"}
            onClick={handleClose}
          />
          <SimpleButton
            text={"Guardar"}
            variant={"liftworld-button-primary"}
            onClick={handleSaveData}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalUpdateClient;
